// src/pages/Company/CareersPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider, Grid, Card, CardContent, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Work, LocationOn, AttachMoney, School, CheckCircle, Email } from '@mui/icons-material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const CareersPage = () => {
  const openPositions = [
    { title: 'Senior Full Stack Developer', location: 'Remote', type: 'Full-time', salary: '$80k - $120k' },
    { title: 'Product Manager', location: 'Remote', type: 'Full-time', salary: '$90k - $130k' },
    { title: 'Customer Success Specialist', location: 'Remote', type: 'Full-time', salary: '$50k - $70k' },
    { title: 'Sales Development Representative', location: 'Remote', type: 'Full-time', salary: '$45k - $60k + commission' },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Join Our Team
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Help us build the future of B2B innovation.
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>
            Why Work at Rengigs?
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Card variant="outlined" sx={{ height: '100%' }}>
                <CardContent>
                  <Work sx={{ fontSize: 40, color: RENGIGS.green, mb: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>Meaningful Work</Typography>
                  <Typography variant="body2" color="text.secondary">Help organizations solve real-world problems and empower suppliers to grow.</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card variant="outlined" sx={{ height: '100%' }}>
                <CardContent>
                  <LocationOn sx={{ fontSize: 40, color: RENGIGS.green, mb: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>100% Remote</Typography>
                  <Typography variant="body2" color="text.secondary">Work from anywhere with a flexible schedule.</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card variant="outlined" sx={{ height: '100%' }}>
                <CardContent>
                  <School sx={{ fontSize: 40, color: RENGIGS.green, mb: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>Learning & Growth</Typography>
                  <Typography variant="body2" color="text.secondary">Annual learning stipend and professional development budget.</Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 3 }}>
          Open Positions
        </Typography>

        {openPositions.map((job, idx) => (
          <Card key={idx} variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>{job.title}</Typography>
              <List dense>
                <ListItem><ListItemIcon><LocationOn fontSize="small" /></ListItemIcon><ListItemText primary={job.location} /></ListItem>
                <ListItem><ListItemIcon><Work fontSize="small" /></ListItemIcon><ListItemText primary={job.type} /></ListItem>
                <ListItem><ListItemIcon><AttachMoney fontSize="small" /></ListItemIcon><ListItemText primary={job.salary} /></ListItem>
              </List>
              <Button variant="outlined" sx={{ color: RENGIGS.green, borderColor: RENGIGS.green }}>Apply Now</Button>
            </CardContent>
          </Card>
        ))}

        <Box sx={{ mt: 4, p: 3, bgcolor: RENGIGS.light, borderRadius: 2, textAlign: 'center' }}>
          <Typography variant="body1" paragraph>
            Don't see a role that fits? Send your resume to <strong>careers@rengigs.com</strong>.
          </Typography>
          <Button variant="contained" startIcon={<Email />} sx={{ bgcolor: RENGIGS.green }}>
            Email Your Resume
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default CareersPage;